import type { ExerciseInput } from '@fitness/api-client';
import { Link, createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { PageHeader } from '@/components/PageHeader';
import { ExerciseForm } from '@/components/exercise/ExerciseForm';
import { describeError } from '@/lib/api';
import { useCreateExercise } from '@/lib/queries/exercises';

export const Route = createFileRoute('/_app/exercises/new')({
  component: NewExercisePage,
});

function NewExercisePage() {
  const navigate = useNavigate();
  const create = useCreateExercise();

  function handleSubmit(input: ExerciseInput): void {
    create.mutate(input, {
      onSuccess: (exercise) => {
        void navigate({ to: '/exercises/$id', params: { id: exercise.id } });
      },
    });
  }

  return (
    <>
      <PageHeader
        title="Nuevo ejercicio"
        subtitle="Se guarda solo para ti y podrás usarlo en tus rutinas."
        action={
          <Link
            to="/exercises"
            search={{}}
            aria-label="Volver al catálogo"
            className="flex size-11 items-center justify-center rounded-xl border border-line text-ink-muted transition-colors hover:bg-surface-raised"
          >
            <ArrowLeft className="size-5" aria-hidden="true" />
          </Link>
        }
      />

      <ExerciseForm
        onSubmit={handleSubmit}
        submitting={create.isPending}
        errorMessage={create.isError ? describeError(create.error, { saving: true }) : undefined}
        errorTitle="No se ha podido crear el ejercicio"
        submitLabel="Crear ejercicio"
        onCancel={() => void navigate({ to: '/exercises', search: {} })}
      />
    </>
  );
}
